import { HandCoins, MessageCircleHeart, MapPin, Smartphone } from "lucide-react";

const POINTS = [
  { icon: HandCoins, title: "Fair prices", text: "Straightforward pricing on phones and repairs — no surprises at the counter." },
  { icon: MessageCircleHeart, title: "Honest advice", text: "If a repair isn't worth it, we'll tell you. If a cheaper phone suits you better, we'll say so." },
  { icon: MapPin, title: "Local & trusted", text: "A friendly, local shop on Market Square that Dungannon people come back to." },
  { icon: Smartphone, title: "Buy and fix in one place", text: "Pick up a new or A+ used phone, get your old one repaired, grab a case — all in one visit." },
];

export const WhyUs = () => (
  <section id="why" className="py-20 md:py-28 bg-ink text-white" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs font-bold tracking-[0.2em] uppercase text-brand">Why FONZ FIX4U</p>
      <h2 className="font-display mt-3 text-3xl sm:text-4xl font-black tracking-tight max-w-2xl">Fair prices, honest advice — from a local shop Dungannon trusts.</h2>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden">
        {POINTS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="bg-ink p-7 md:p-8 hover:bg-white/5 transition-colors" data-testid={`why-point-${title.split(" ")[0].toLowerCase()}`}>
            <Icon className="h-7 w-7 text-brand" />
            <h3 className="font-display mt-5 text-xl font-bold">{title}</h3>
            <p className="mt-2 text-sm text-slate-300 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
